function cleanResponse (text) {
  return text
    .replace(/\$\\rightarrow\$/g, '→')
    .replace(/\\rightarrow/g, '→')
    .replace(/\$\\leftarrow\$/g, '←')
    .replace(/\\uparrow/g, '↑')
    .replace(/\\downarrow/g, '↓')
    .replace(/\$([^$]*)\$/g, '$1')
    .replace(/\*\*([^*]+)\*\*/g, '$1')
    .replace(/^#{1,6}\s+/gm, '')
    .replace(/^---+$/gm, '')
}

function readMessages (messages, errorKey = null) {
  if (!Array.isArray(messages)) return []
  return messages.map(message => ({
    ...message,
    content: message.role === 'assistant' ? cleanResponse(message.content) : message.content,
    ...(errorKey && message.role === 'error' ? { uiKey: errorKey } : {})
  }))
}

function requestError (error, fallbackKey, missingConversation = false) {
  const status = error.response && error.response.status
  const data = (error.response && error.response.data) || {}
  let errorKey = fallbackKey
  if (status === 401) {
    errorKey = 'chatbot.errors.authExpired'
  } else if (status === 403) {
    errorKey = 'chatbot.errors.accessDenied'
  } else if (status === 404) {
    errorKey = missingConversation
      ? 'chatbot.errors.conversationUnavailable'
      : 'chatbot.errors.serviceNotConfigured'
  } else if (status === 429) {
    // Minute, rolling-day and provider limits share 429. Do not guess which
    // quota expired or when it resets from this status alone.
    errorKey = 'chatbot.errors.rateLimited'
  } else if (status === 503) {
    errorKey = 'chatbot.errors.serviceUnavailable'
  } else if (status === 422) {
    errorKey = 'chatbot.errors.invalidMessage'
  }
  return {
    success: false,
    status,
    errorKey,
    message: data.message || '',
    conversationId: data.conversation_id || null,
    messages: readMessages(data.messages, errorKey)
  }
}

export async function listConversations (page = 1) {
  try {
    const { data } = await window.axios.get('chatbot/conversations', {
      params: { page },
      timeout: 20000
    })
    return { success: true, conversations: data.conversations, nextPage: data.next_page }
  } catch (error) {
    return requestError(error, 'chatbot.errors.historyLoad')
  }
}

export async function getConversation (conversationId, beforeId = null) {
  try {
    const { data } = await window.axios.get(`chatbot/conversations/${conversationId}/messages`, {
      params: beforeId ? { before_id: beforeId } : {},
      timeout: 20000
    })
    return {
      success: true,
      conversation: data.conversation,
      messages: readMessages(data.messages),
      nextBeforeId: data.next_before_id
    }
  } catch (error) {
    return requestError(error, 'chatbot.errors.messagesLoad', true)
  }
}

export async function sendMessage (message, conversationId = null) {
  try {
    const { data } = await window.axios.post('chatbot/completions', {
      message,
      ...(conversationId ? { conversation_id: conversationId } : {})
    }, {
      timeout: 60000
    })
    return {
      success: true,
      message: cleanResponse(data.message),
      conversationId: data.conversation_id,
      messages: readMessages(data.messages)
    }
  } catch (error) {
    return requestError(error, 'chatbot.errors.sendUnconfirmed', !!conversationId)
  }
}
